import './Blockquote.css';
export var blockquoteCSS = '_1knl9z60-3-5-0';